import { formatInTimeZone } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export type TimeWindow = { start: string; end: string };

export function timeToMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

export function addMinutesToTime(time: string, minutesToAdd: number): string {
  const total = timeToMinutes(time) + minutesToAdd;
  const hours = Math.floor(total / 60) % 24;
  const mins = total % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

export function subtractAppointmentsFromWindows(
  windows: TimeWindow[],
  appointments: Array<{ startAt: string; duration: number }>,
  dateISO: string,
  timezone: string,
  bufferMinutes: number,
): Array<{ startMinutes: number; endMinutes: number }> {
  const dayAppointments = appointments
    .filter((a) => {
      const aptDateInTz = formatInTimeZone(
        parseISO(a.startAt),
        timezone,
        'yyyy-MM-dd',
      );
      return aptDateInTz === dateISO;
    })
    .sort(
      (a, b) => new Date(a.startAt).getTime() - new Date(b.startAt).getTime(),
    );

  const result: Array<{ startMinutes: number; endMinutes: number }> = [];

  windows.forEach((win) => {
    const winStart = timeToMinutes(win.start);
    const winEnd = timeToMinutes(win.end);
    let current = winStart;

    dayAppointments.forEach((apt) => {
      const aptTimeInTz = formatInTimeZone(
        parseISO(apt.startAt),
        timezone,
        'HH:mm',
      );
      const aptStart = timeToMinutes(aptTimeInTz);
      const aptEnd = aptStart + apt.duration;

      if (aptStart >= winEnd || aptEnd <= winStart) return;

      if (aptStart - current > bufferMinutes) {
        result.push({
          startMinutes: current,
          endMinutes: Math.min(aptStart, winEnd),
        });
      }
      current = Math.max(current, aptEnd);
    });

    if (winEnd - current > bufferMinutes) {
      result.push({ startMinutes: current, endMinutes: winEnd });
    }
  });

  return result;
}
